<template>
  <header id="page_header" :class="theme">
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="cell shrink">
                <a href="https://pravo.ru/" target="_blank" class="logo pravo"></a>
            </div>
            <div class="cell auto hide-for-small-only">
                <div class="arr_wrapper">
                    <router-link v-if="casesSwitch.prev" :to="casesSwitch.prev.href" class="header_arr header_prev">{{ casesSwitch.prev.year }}</router-link>
                </div>
                <button type="button" v-if="theme == 'dark'" @click="overlayClose">На главную</button>
                <div class="arr_wrapper">
                    <router-link v-if="casesSwitch.next" :to="casesSwitch.next.href" class="header_arr header_next">{{ casesSwitch.next.year }}</router-link>
                </div>
            </div>
            <div class="cell auto large-shrink medium-shrink">
                <a href="http://www.phplaw.ru/" target="_blank" class="logo hlyustov">
                    Адвокатское бюро<br>Павел Хлюстов и<br class="hide-for-large"> Партнёры
                </a>
            </div>
        </div>
    </div>
  </header>
</template>

<script>
export default {
    name: "Page_header",
    data: () => ({
        theme:"light", casesSwitch: {prev:false, next:false}
    }),
    created(){
        if(this.$route.name != 'index' && this.$route.name != 'slides') this.theme = 'dark'
        this.$root.$on('showOverlay', () => this.theme = 'dark')
        this.$root.$on('hideOverlay', () => this.theme = 'light')
        this.$root.$on('setNav', data => this.updateNav(data))
    },
    updated(){
        this.$root.$on('setNav', data => this.updateNav(data))
    },
    methods: {
        overlayClose(){
            this.$root.$emit('hideOverlay')
        },
        updateNav(data){
            if(data){
                let caseIdx = slides.indexOf(data)
                let prevCase = slides[caseIdx-1]
                let nextCase = slides[caseIdx+1]

                if(prevCase && caseIdx != 1){
                    this.casesSwitch.prev = { year:prevCase.year, href:`/cases/${caseIdx-1}` }
                } else {
                    this.casesSwitch.prev = false
                }
                if(nextCase && caseIdx+1 != slides.length){
                    this.casesSwitch.next = { year:nextCase.year, href:`/cases/${caseIdx+1}` }
                } else {
                    this.casesSwitch.next = false
                }
            } else {
                this.casesSwitch = { prev:false, next:false }
            }
        }
    }
};
</script>

<style lang="scss">
    #page_header {
        .cell {
            display:flex; align-content:center; justify-content:center;
        }
        .logo {
            display:inline-block; align-self:center; //filter:drop-shadow(0.5px 0.5px 0.6px rgba(0, 0, 0, 0.8));

            &.pravo {
                background:url("~@/./assets/img/logo_pravo.png") no-repeat top left/100%; height:20px; width:120px; transition:filter 1s ease;
            }

            &.hlyustov {
                position:relative; padding-right:30%; text-align:right; color:#fff; font-family:$sans-serif; font-size:fsz(.85rem); line-height:1; padding-top:$space*1.5; transition:color 1s ease; text-shadow:.5px .5px .6px rgba(0,0,0,.8);

                &:after {
                    content:""; position:absolute; top:0; right:0; width:26%; height:90%; background:#fff url("~@/./assets/img/phplaw_logo.png") no-repeat center center/80%; box-shadow:0 0 3px rgba(0,0,0,.8)
                }
                height:70px; width:300px; float:right; 

                @include small {
                    font-size:.6rem; height:42px; padding-top:8px;
                    &:after { height:100% }
                }

                @include medium {
                    font-size:.6rem; height:42px; padding-top:8px; width:200px;
                    &:after { height:100% }
                }
            }
        }

        @include small {
            background:rgba(27, 14, 31, .8)
        }

        &.dark {
            background:rgba(255,255,255,.95); z-index:5;
            .logo.pravo { background:url("~@/./assets/img/logo_pravo_colored.jpg") no-repeat top left/100%; }
            .logo.hlyustov {
                color:#000; text-shadow:none;
                &:after { box-shadow:none }
            }
        }

        button {
            text-transform:uppercase; font-family:$sans-serif; font-weight:bold; cursor:pointer; position:relative; padding-left:$space/2;
            &:focus { outline:none; }
        }

        .arr_wrapper {
            position:relative; align-self:center; min-width:calc(32px + #{$space*5});
        }

        .header_arr {
            color:#000;
            &:before { content:""; position:absolute; top:50%; left:-$space*1.2; transform:translateY(-50%); border-style:solid; border-width:6px 12px 6px 0; border-color:transparent $yellow transparent transparent; transition:left .2s ease }
            &:hover:before { left:-$space*1.5; transition:left .2s ease }

            &.header_prev { margin-right:$space*5 }
            &.header_next {
                margin-left:$space*5;
                &:before { content:none }
                &:after { content:""; position:absolute; top:50%; right:-$space*1.2; transform:translateY(-50%); border-style:solid; border-width:6px 0 6px 12px; border-color:transparent transparent transparent $yellow; transition:right .2s ease }
                &:hover:after { right:-$space*1.5; transition:right .2s ease }
            }
        }
    }
</style>